import AlternativeContractAPI from "../../../api/AlternativeContractAPI";
import AlternativeContract from "../../../models/alternativeContract/AlternativeContract";
import ContractAggregateAPI from "../../../api/ContractAggregateAPI";

export default {
  async getAllAlternativeContracts({
    commit
  }, data) {
    const response = await new AlternativeContractAPI().getAlternativeContracts(data);
    const allAlternativeContracts = [];
    for (let i = 0; i < response.length; i++) {
      const element = response[i];
      const alternativeContract = AlternativeContract.createFromData(element);
      allAlternativeContracts.push(alternativeContract);
    }
    commit("SET_ALL_ALTERNATIVE_CONTRACTS", allAlternativeContracts);
    return response;
  },

  async getAlternativeCount({commit}, data) {
    return await new AlternativeContractAPI().getAlternativeCount(data);
  },

  async createAlternativeContract({
    state,
    commit
  }) {
    let lessorIds = [];
    for (let i = 0; i < state.addedAlternativeLessorsIds.length; i++) {
      if (state.addedAlternativeLessorsIds[i] !== '') {
        lessorIds.push(state.addedAlternativeLessorsIds[i]);
      }
    }
    state.currentAlternativeContract.lessorIds = lessorIds;

    const response = await new AlternativeContractAPI().createAlternativeContract(state.currentAlternativeContract);
    commit('ADD_ALTERNATIVE_CONTRACT', response);
  },

  async updateAltContract({state, commit}, payload) {
    await new AlternativeContractAPI().updateAltContract(payload.data, payload.contractId);
  },

  async getAlternativeContractById({
    commit
  }, id) {
    const response = await new AlternativeContractAPI().getAlternativeContractById(id);
    const alternativeContract = AlternativeContract.createFromData(response);
    commit("SET_CURRENT_ALTERNATIVE_CONTRACT", alternativeContract);
  },

  async alternativeContractImport({commit}, data) {
    return await new AlternativeContractAPI().excelImport(data);
  }

};
